export var getFormattedCombinedFeatures = function (features) {
    return features.reduce(function (acc, _a) {
        var scope = _a.scope, featureKeys = _a.featureKeys, key = _a.key, attributes = _a.attributes;
        featureKeys.forEach(function (featureKey) {
            var featureRequestData = {
                scope: scope,
                featureKey: featureKey,
                key: key,
                attributes: attributes,
            };
            acc.push(featureRequestData);
        });
        return acc;
    }, []);
};
